import { Container, Grid } from '@mui/material';
import { FC, ReactNode } from 'react';

interface ContentWrapperProps {
    children: ReactNode;
    dataTestId?: string;
    maxContentWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ContentWrapper: FC<ContentWrapperProps> = ({
    children,
    dataTestId,
    maxContentWidth = 'sm',
}) => (
    <Grid
        data-test-id={dataTestId}
        id="content-wrapper"
        sx={{ height: '100%', position: 'relative', width: '100%', zIndex: 1 }}
    >
        <Container maxWidth={maxContentWidth}>{children}</Container>
    </Grid>
);

export default ContentWrapper;
